import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { useGetSide } from './hooks/useGetSide';
export const BlockSide = ({ dataTestId, fetchItems, itemLoader: ItemLoader, itemRenderer: ItemRenderer, queryId, topicId, }) => {
    const { data, isError, isLoading } = useGetSide({
        fetchItems,
        queryId,
        topicId,
    });
    if (isLoading) {
        return ItemLoader ? _jsx(ItemLoader, {}) : null;
    }
    if (!data || isError) {
        return null;
    }
    return (_jsx(Box, { "data-testid": dataTestId, display: "block", width: "100%", children: _jsx(ItemRenderer, { data: data }) }));
};
//# sourceMappingURL=index.js.map